export default "__VITE_ASSET__si08MZW$__"